import { SLHeaders } from '@travelwin/core';

import {
  TikTokEvent,
  tikTokPixelAttributesToHeaders,
} from '../../components/TikTokPixel';
import { getApiUrl, request } from '../helpers/requests';

export const sendEvent = async ({
  sessionId,
  event,
  origin,
}: {
  sessionId: string;
  event: TikTokEvent;
  origin?: string;
}): Promise<void> => {
  const options = {
    method: 'POST',
    headers: {
      ...tikTokPixelAttributesToHeaders(),
      [SLHeaders.SESSION_ID]: sessionId,
      ...(origin ? { [SLHeaders.ORIGIN]: origin } : {}),
    },
    body: JSON.stringify(event),
  };
  return await request(`${getApiUrl()}ecommerce/tik_tok_event`, options);
};
